function template(id, title, location, activities, company_logo_location) {
  var companyTemplate = "";

  companyTemplate = '<div id="company_' + id + '" class="item list_company object small"><div class="object-content"><div class="object-thumb"><img src="' + company_logo_location + '"></div>';
  companyTemplate += '<div class="object-details"><a class="object-name" href="#">' + title + '</a><div class="data-list"><div class="data-item"><div class="data-value">' + location + '</div></div></div></div>';
  companyTemplate += '<div class="row-actions"><a href="javascript:;" class="button icon-btn pt-delete micro icon remove temp-remove" title="delete company" data-id="' + id + '"></a></div>';
  companyTemplate += '</div></div>';

  return companyTemplate;
}

// function to remove company from the list of companies
function remove_company_from_list(CompanyId) {

  // TODO: something wrong with remove element at first time
  $('#company_' + CompanyId).remove();
  setTimeout((function () {
    $('#company_' + CompanyId).remove();
  }), 100);

  var CompanyIdsToRemove = $('#list_remove_companies').val();
  var PreviousValues = '';
  if (CompanyIdsToRemove.length != 0) {
    PreviousValues = CompanyIdsToRemove + ',';
  }
  $('#company_' + CompanyId + '.item.list_company').parent('.result').show();
  $('#list_remove_companies').val(PreviousValues + CompanyId);

  existing_companies = $('#list_existing_companies').val().split(',');

  existing_companies = jQuery.grep(existing_companies, function (value) {
    return value != CompanyId;
  });

  $('#list_existing_companies').val(existing_companies + "");
}

// function to add a company to the list of companies
function add_company_to_list(CompanyId) {
  // Get the values from the hidden field in the HTML form
  var CompanyIdsToAdd = $('#list_add_companies').val();
  var PreviousValues = '';
  if (CompanyIdsToAdd.length != 0) {
    PreviousValues = CompanyIdsToAdd + ',';
  }

  $('#company_' + CompanyId + '.item.list_company').parent('.result').hide();
  $('#list_add_companies').val(PreviousValues + CompanyId);

  existing_companies = $('#list_existing_companies').val().split(',');
  existing_companies.push(CompanyId);
  $('#list_existing_companies').val(existing_companies + "");
}

$(function () {
  $("#existing_companies .list-items").on('click', '.temp-remove', function (event) {
    remove_company_from_list($(this).data('id'));
    if ($('#existing_companies .item').length == 0) {
      $('#existing_companies .list-items').append('No companies selected');
    }
  });
});

// Check either member company exist or not
function member_company_exist(CompanyId) {
  return ($('#existing_companies .list-items').find("#company_" + CompanyId).length)
};

$(document).ready(function () {
  if ($('#existing_companies .item').length == 0) {
    $('#existing_companies .list-items').append('No companies selected');
  }

  // betterAutocomplete is a legacy Sprockets vendor plugin — may not be loaded on all pages.
  // Guard to prevent TypeError if the plugin is absent.
  if (!$.fn.betterAutocomplete) return;

  $('#list_company_ids_to_add').betterAutocomplete('init', '/workplace/company/lists/filter_companies', { charLimit: 2, cacheLimit: 0, remoteTimeout: 20000 },
    {
      themeResult: function (result) {
        if (member_company_exist(result.id)) {
          return;
        }
        output = template(result.id, result.text, result.address, result.title, result.image);
        return output;
      },
      select: function (result, $input) {
        $input.blur();
        if ($('#existing_companies .item').length == 0) {
          $('#existing_companies .list-items').text('');
        }
        $("#existing_companies .list-items").prepend(template(result.id, result.text, result.address, result.activities, result.image));
        add_company_to_list(result.id);
      },
      beginFetching: function ($input) {
        $('#loading_text').show();
      },
      finishFetching: function ($input) {
        $('#loading_text').hide();
      },
      fetchRemoteData: function (url, completeCallback, timeout, crossOrigin) {
        $('#no_company_found').hide();
        $.ajax({
          url: url,
          data: { ec_ids: $('#list_existing_companies').val() },
          dataType: crossOrigin && !$.support.cors ? 'jsonp' : 'json',
          timeout: timeout,
          success: function (data, textStatus) {
            if (data == '') { $('#no_company_found').show(); }
            completeCallback(data);
          },
          error: function (jqXHR, textStatus, errorThrown) {
            completeCallback();
          }
        });
      }
    });
});
